import React, { useState, useRef } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';

const useMyPageHook = () => {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { setMessage } = useComnStore();//메세지결과처리
    const { partner, info, setInfo } = usePartnerStore();

    /* =============== 정비인원arrayList =============== */
    const [ mechanicList,setMechanicList ] = useState([]);
    const setMechanicOptionHandler = () => {
        let newList = [];
        for(let i = 1; i <= 10; i++) {
            newList.push({ name:i+'명', value:i });
		}
        setMechanicList(newList);
    }
    /* =============== 정비인원arrayList =============== */

    const inputRef = useRef([]);
    /* =============== 버튼활성화여부 =============== */
    const [ isDisabled,setDisabled ] = useState(true);
    const onValidHandler = () => {
        let disabled = false;
        for(let i = 0; i < inputRef.current.length; i++) {
            if(i < 2 && inputRef.current[i]?.value?.length <= 0) { disabled = true; break; }
            if(inputRef.current[0].value === info.PARTNER_NAME && inputRef.current[1]?.value === info.MECHANIC && inputRef.current[2].value === info.SUMMARY) { disabled = true; break; }
        }
        setDisabled(disabled);
    }
    /* =============== 버튼활성화여부 =============== */
    /* =============== 회원정보수정 =============== */
    const isLock = useRef(false);
    const partnerUpdateAPI = async() => {
        if(isLock.current) { return; }
        
        isLock.current = true;
        const DATA = { PARTNER_CD:partner.COMN_CD, PARTNER_NAME:inputRef.current[0].value, MECHANIC:inputRef.current[1].value ?? info.MECHANIC, SUMMARY:inputRef.current[2].value };
        const result = await axiosPostHandler(`partnerMasterUpdateForPartner.do`, DATA);
        setTimeout(function() { isLock.current = false; }, 300);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            // props.onDismiss(false);

            let newData = info;
            newData.PARTNER_NAME = DATA.PARTNER_NAME;
            newData.MECHANIC = DATA.MECHANIC;
            newData.SUMMARY = DATA.SUMMARY;
            setInfo(newData);
            setMessage({type:1, message:'업체 정보가 변경되었습니다.'});

            return true;
        }
    }
    /* =============== 회원정보수정 =============== */



    //입력검증핸들러
    const updateRef1 = useRef([]);//bottomsheet
    const updateRef2 = useRef([]);//init
    const [ btnDisabled, setBtnDisabled ] = useState(true);
    const inputValidateRef1Handler = () => { inputValidateHandler(updateRef1); }
    const inputValidateRef2Handler = () => { inputValidateHandler(updateRef2); }
    const inputValidateHandler = (updateRef) => {
        let bval = true;
        for(let i = 0; i < (updateRef.current.length - 1); i++) {
            if(typeof updateRef.current[i].value == 'undefined') { bval = false;}
            else {
                if(updateRef.current[i].value.toString().length > 0) { bval = false; }
                if(updateRef.current[i].value.toString().length <= 0) { bval = true; break; }
            }
        }
        setBtnDisabled(bval);
    }

    //팝업버튼핸들러
    const [ isOpen, setIsOpen ] = useState(false);
    const handleDismissChange = (value) => {
        setIsOpen(value);
    }

    return { setMechanicOptionHandler, mechanicList//정비인원수
        , isDisabled, onValidHandler//회원정보수정 버튼활성화여부
        , inputRef, partnerUpdateAPI//회원정보수정
        



        , updateRef1, updateRef2, btnDisabled, inputValidateRef1Handler, inputValidateRef2Handler//회원정보수정-입력
        , partnerUpdateAPI//파트너수정API
        //회원정보수정팝업
        , handleDismissChange, isOpen//팝업openHandler
    };
}

export default useMyPageHook;